import './subpage_wrapper.less';

import React, { Component } from 'react';
import classNames from 'classnames';

import autobind from 'class-autobind';

import $ from 'jquery';
import debounce from 'lodash/debounce';

import {
  APP_CONTAINER_SELECTOR
} from 'zoomforth_codesbane_viewer/const/dom_selectors.js';

const SUBPAGE_RESIZE_EVENT = 'resize.subpage';


class SubpageFullPageSectionWrapper extends Component {
  constructor() {
    super();
    autobind(this);
  }

  componentDidMount() {
    const { hasDisplayableContent } = this.props;

    $(window).on(SUBPAGE_RESIZE_EVENT, debounce(this.calculateFullPageSectionHeight, 100));

    if (hasDisplayableContent) {
      $(window).trigger(SUBPAGE_RESIZE_EVENT);
    }
  }

  componentDidUpdate() {
    const { hasDisplayableContent } = this.props;

    if (hasDisplayableContent) {
      this.calculateFullPageSectionHeight();
    }
  }

  componentWillUnmount() {
    $(window).off(SUBPAGE_RESIZE_EVENT);
  }

  calculateFullPageSectionHeight() {
    if (!this.props.hasDisplayableContent) {
      return;
    }

    const section = $(APP_CONTAINER_SELECTOR).find('.section-wrapper').first();
    var height = $(window).height() - section.offset().top;

    if ($('.template-notification-banner').length > 0) {
      height -= $('.template-notification-banner').height();
    } else if ($('.hidden-subpage-banner').length > 0) {
      height -= $('.hidden-subpage-banner').height();
    }

    section.height(height);
    section.width('100%');
  }

  render() {
    const { cssClassesList, isTemplate, children } = this.props;

    return (
      <div
        className={classNames('subpage-is-fullpage', {
          'page-is-template': isTemplate
        }, cssClassesList)}
      >
        { children }
      </div>
    );
  }
}

export default SubpageFullPageSectionWrapper;
